import { Amplify } from 'aws-amplify';

// Load amplify configuration from public folder.
// Analytics: GA4 (utils/analytics.js) is the site's analytics. The old Pinpoint
// `record()` call was removed 2026-09-06: it returned 403 on every page load
// (uncaught promise in the console) and AWS retires Pinpoint on 2026-10-30.
// The Pinpoint app in amplify/backend.ts can be removed in a follow-up.
fetch('/amplify_outputs.json')
  .then(response => response.json())
  .then(config => {
    Amplify.configure(config);
  })
  .catch(error => {
    console.error('Failed to load Amplify configuration:', error);
  });
